import React from 'react'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControl from '@material-ui/core/FormControl'
import { makeStyles } from '@material-ui/core/styles'
import styles from '../../styles'
import { ClassValue } from 'classnames/types'
import { useMediaQuery } from 'react-responsive'
import classNames from 'classnames'
import FormControlLabelField from './FormControlLabelField'
import { FieldRenderProps } from 'react-final-form'

const useStyles = makeStyles(
	(theme) => (
		{
			...styles(theme),
			formControl: {
				width: '100%'
			},
			radioGroupRow: {
				flexDirection: 'row'
			},
			radioGroupColumn: {
				flexDirection: 'column'
			},
			smallGroup: {
				justifyContent: 'space-between'
			},
			largeGroup: {
				'& label:not(:first-child)': {
					marginLeft: 150
				}
			},
			errorStyle: {
				color: '#B92D00',
				fontSize: 10
			}
		}
	)
)

interface RadioItem {
	label: string,
	value: string
}

interface AcceptingProps {
	items: RadioItem[],
	textStyle: string,
	textColor: string,
	textWeight?: string,
	margin: boolean,
	rowDirection: boolean,
}

type RadioFieldProps = AcceptingProps & FieldRenderProps<string>

const FormRadioField: React.FC<RadioFieldProps> = (
	{
		input,
		items,
		textStyle,
		textColor,
		textWeight,
		margin,
		rowDirection,
		meta: {
			error,
			touched
		}
	}
) => {
	const classes = useStyles()
	const isMobileScreen = useMediaQuery(
		{
			query: '(max-width: 500px)'
		}
	)
	const radioGroupClass: ClassValue = classNames(
		rowDirection ? classes.radioGroupRow : classes.radioGroupColumn,
		!isMobileScreen && margin && classes.largeGroup,
		isMobileScreen && classes.smallGroup
	)

	return (<FormControl component="fieldset" className={classes.formControl}>
			<RadioGroup
				className={radioGroupClass}
				{...input}
			>
				{items.map((item: RadioItem, index: number) =>
					<FormControlLabelField
						key={`radio-${input.name}-${index}`}
						label={item.label}
						value={item.value}
						textStyle={textStyle}
						textColor={textColor}
						textWeight={textWeight}
					/>
				)}
			</RadioGroup>

			{
				touched && error && <span className={classes.errorStyle}>{error}</span>
			}
		</FormControl>
	)
}

export default FormRadioField
